module.exports = __webpack_public_path__ + "static/media/PATS_3-768w.2bb27883.png";